import { Interaction, InteractionItem, InteractionModeFunction } from 'chart.js';
import Utils from '../utils/utils';

declare module 'chart.js' {
  interface InteractionModeMap {
    pointNearest: InteractionModeFunction;
  }
}

Interaction.modes.pointNearest = (chart, e, options, useFinalPosition): InteractionItem[] => {
  const pointItems = Interaction.modes.point(
    chart,
    e,
    { axis: 'xy', intersect: false },
    useFinalPosition
  );
  if (!pointItems.length) {
    return Interaction.modes.nearest(chart, e, { intersect: false, axis: 'x' }, useFinalPosition);
  }
  return Utils.uniqArray(pointItems, (a, b) => a.datasetIndex === b.datasetIndex);
};
